import { useCallback, useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"

import { claimNextConversationFromQueue } from "api"
import { ACTIV_HALSA_NURSE_QUEUE } from "config"
import { useAppDispatch, useAppSelector } from "lib/hooks"
import { setActivHalsaNurseNotification } from "reducers/app"

import { NextConversationComponentProps } from "./NextConversation"
import ClaimNextConversation from "./shared/ClaimNextConversation"

const NextConversationList = ({
  autoassignTimer,
  isBlocked,
  queues,
  appLanguage,
  personalQueue,
  personalQueueKeys
}: NextConversationComponentProps) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [isClaiming, setIsClaiming] = useState(false)
  const activHalsaNurseNotification = useAppSelector(state => state.app.activHalsaNurseNotification)

  const getQueueName = useCallback(
    (queueKey: string) => {
      return queues.find(queue => queue.queueKey === queueKey)?.translations[appLanguage] || ""
    },
    [appLanguage, queues]
  )

  const statsPerQueue = useMemo(() => {
    return (
      personalQueueKeys?.map(pQueueKey => {
        const convs = personalQueue.filter(c => c.queue === pQueueKey)
        const waitTime = convs[0]?.queuePriority
        const count = convs.length

        return {
          key: pQueueKey,
          count,
          waitTime,
          showContactMyClinic: pQueueKey === "contact_my_clinic"
        }
      }) || []
    )
  }, [personalQueue, personalQueueKeys])

  // Clear notification when activ_halsa_nurse queue is empty
  useEffect(() => {
    const activHalsaNurseQueue = statsPerQueue?.find(queue => queue.key === ACTIV_HALSA_NURSE_QUEUE)
    if (activHalsaNurseQueue && activHalsaNurseQueue.count === 0 && activHalsaNurseNotification) {
      dispatch(setActivHalsaNurseNotification(false))
    }
  }, [statsPerQueue, activHalsaNurseNotification, dispatch])

  const grabConversation = async (queueKey: string) => {
    if (!isBlocked && !isClaiming) {
      setIsClaiming(true)
      await dispatch(claimNextConversationFromQueue(navigate, queueKey))
      setIsClaiming(false)
    }
  }

  return (
    <>
      {statsPerQueue &&
        statsPerQueue?.map(queue => (
          <ClaimNextConversation
            queueName={getQueueName(queue.key)}
            conversationCount={queue.count}
            queueTime={queue.waitTime}
            isBlocked={isBlocked}
            autoassignTimer={autoassignTimer}
            grabConversation={() => grabConversation(queue.key)}
            key={queue.key}
            showContactMyClinicCounter={queue.showContactMyClinic}
            showNotification={queue.key === ACTIV_HALSA_NURSE_QUEUE && activHalsaNurseNotification}
          />
        ))}
    </>
  )
}

export default NextConversationList
